/*
 * Proprietary and confidential | 2023 | SoundTalks NV
 */

import React from 'react';

import cx from 'classnames';

import s from './styles.module.scss';

interface ContentBoxProps extends React.HTMLAttributes<HTMLDivElement> {
  className?: string;
  children?: React.ReactNode;
}

const ContentBox = ({ className, children, ...props }: ContentBoxProps) => (
  <div {...props} className={cx(s.contentBox, className)}>
    {children}
  </div>
);

export default ContentBox;
